module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_67520887_L-small-d6feccf84106aaf71e56ec61f78aff5d.jpg";